{
    "title": "التحكم بالعرض التوضيحي",
    "subtitle": "حرّك الساعة، واحفظ الحالة، وشغّل سيناريو معدّاً. كل ما في هذه الصفحة يعمل على قاعدة البيانات الحقيقية، ولا شيء فيها محاكاة.",
    "tabs": {
        "control": "التحكم",
        "scenarios": "السيناريوهات"
    },

    "clock": {
        "title": "الساعة",
        "help": "تحرّك إحساس المنصّة بـ«الآن» ليُشاهَد تجاوز المهلة أو المعالجة الليلية أو التقرير المجدول وهو يحدث، لا أن يُوصف. ولا يخرجك ذلك من الحساب: يُقاس الخمول بالساعة الحقيقية.",
        "simulated": "تعتقد المنصّة أن الوقت",
        "real": "الوقت الفعلي",
        "travelling": "متنقّلة في الزمن",
        "real_time": "الوقت الحقيقي",
        "offset": "الإزاحة",
        "offset_value_zero": "لا إزاحة",
        "offset_value_one": "يوم واحد إلى الأمام",
        "offset_value_two": "يومان إلى الأمام",
        "offset_value_few": "{{count}} أيام إلى الأمام",
        "offset_value_many": "{{count}} يوماً إلى الأمام",
        "offset_value_other": "{{count}} يوم إلى الأمام",
        "offset_behind_zero": "لا إزاحة",
        "offset_behind_one": "يوم واحد إلى الوراء",
        "offset_behind_two": "يومان إلى الوراء",
        "offset_behind_few": "{{count}} أيام إلى الوراء",
        "offset_behind_many": "{{count}} يوماً إلى الوراء",
        "offset_behind_other": "{{count}} يوم إلى الوراء",
        "offset_hours_zero": "لا إزاحة",
        "offset_hours_one": "ساعة واحدة إلى الأمام",
        "offset_hours_two": "ساعتان إلى الأمام",
        "offset_hours_few": "{{count}} ساعات إلى الأمام",
        "offset_hours_many": "{{count}} ساعة إلى الأمام",
        "offset_hours_other": "{{count}} ساعة إلى الأمام",
        "forward_hours": "+{{count}} ساعات",
        "forward_days_zero": "+{{count}} يوم",
        "forward_days_one": "+يوم واحد",
        "forward_days_two": "+يومان",
        "forward_days_few": "+{{count}} أيام",
        "forward_days_many": "+{{count}} يوماً",
        "forward_days_other": "+{{count}} يوم",
        "back_days_zero": "−{{count}} يوم",
        "back_days_one": "−يوم واحد",
        "back_days_two": "−يومان",
        "back_days_few": "−{{count}} أيام",
        "back_days_many": "−{{count}} يوماً",
        "back_days_other": "−{{count}} يوم",
        "to_date": "الانتقال إلى تاريخ",
        "go": "انتقل",
        "reset": "العودة إلى الوقت الحقيقي",
        "expires": "تدوم الإزاحة يوماً واحداً ثم تسقط تلقائياً، حتى لا يترك عرضٌ العرضَ الذي يليه في المستقبل."
    },

    "data": {
        "title": "البيانات",
        "profile": "ملف البذر",
        "profile_full": "كامل — أحجام قريبة من الإنتاج",
        "profile_test": "اختباري — صغير، لمجموعة الاختبارات",
        "counts": "المحمّل حالياً",
        "reset": "إعادة بناء قاعدة البيانات",
        "reset_help": "يحذف كل شيء، ويعيد تشغيل الترحيلات والبذر. النتيجة حتمية: تعود السجلات نفسها بالمعرّفات نفسها في كل مرة.",
        "reset_confirm_title": "إعادة بناء قاعدة البيانات؟",
        "reset_confirm_body": "يُفقد كل ما أُدخل في هذه الجلسة، بما في ذلك ما كتبه المقيِّم للتو. تستغرق العملية نصف دقيقة تقريباً.",
        "reset_running": "جارٍ إعادة البناء…",
        "reset_done": "أُعيد البناء في {{seconds}} ثانية.",
        "row_customers": "العملاء",
        "row_complaints": "الشكاوى",
        "row_interactions": "التفاعلات",
        "row_queue_tickets": "تذاكر الانتظار",
        "row_cc_conversations": "المحادثات",
        "row_survey_responses": "ردود الاستبيانات",
        "row_daily_metrics": "المؤشرات اليومية",
        "row_users": "المستخدمون"
    },

    "snapshots": {
        "title": "النسخ",
        "help": "النسخة هي قاعدة البيانات كاملة، تُحفظ في ثانية. خذ نسخة قبل أن يجرّب المقيِّم أمراً مدمّراً، واستعدها بعد أن يجرّبه.",
        "name": "اسم النسخة",
        "name_placeholder": "قبل-اجتماع-المجلس",
        "take": "خذ نسخة",
        "restore": "استعادة",
        "restore_confirm_title": "استعادة «{{name}}»؟",
        "restore_confirm_body": "تُستبدل قاعدة البيانات الحالية بالمحفوظة وتعود الساعة إلى الوقت الحقيقي. ويُفقد كل ما جرى بعد أخذ النسخة.",
        "delete": "حذف",
        "delete_confirm_title": "حذف «{{name}}»؟",
        "delete_confirm_body": "تُحذف النسخة المحفوظة، ولا تُمس قاعدة البيانات الحيّة.",
        "empty": "لا توجد نسخ بعد.",
        "taken": "أُخذت",
        "size": "الحجم",
        "unavailable": {
            "demo_mode_off": "تحتاج النسخ إلى وضع العرض التوضيحي.",
            "unsupported_driver": "النسخة هنا نسخُ ملف SQLite. مع PostgreSQL استخدم أدوات النسخ الاحتياطي لديك، إذ يحتاج pg_dump إلى أدوات العميل وصلاحيات لا يمكن للتطبيق افتراض توفرها.",
            "in_memory_database": "لا يوجد في هذا التركيب ملف قاعدة بيانات لنسخه."
        }
    },

    "scenarios": {
        "title": "سيناريوهات معدّة",
        "help": "يجيب كل سيناريو عن سؤال يحق للمقيِّم أن يسأله، في دقائق، وعلى بيانات مبذورة.",
        "minutes": "{{count}} دقيقة",
        "steps_zero": "{{count}} خطوة",
        "steps_one": "خطوة واحدة",
        "steps_two": "خطوتان",
        "steps_few": "{{count}} خطوات",
        "steps_many": "{{count}} خطوة",
        "steps_other": "{{count}} خطوة",
        "open": "افتح",
        "run": "نفّذها عني",
        "not_ready": "لا تدعم البيانات المبذورة هذا السيناريو حالياً. أعد بناء قاعدة البيانات لاستعادته.",
        "step": "الخطوة {{number}}"
    },

    "errors": {
        "name_required": "أعطِ النسخة اسماً."
    }
}
